export const DATA_MANAGER_HISTORY_FIELD_LABELS = {
  product_compartment_fill_enabled: "Expansion des produits",
  product_compartment_fill_rules: "Règles par produit",
  compartment_sharing_enabled: "Compléter un compartiment",
  hourly_rate_override: "Exception $/h",
  loading_tonne_rate_override: "Exception $/t",
  fixed_rate_override: "Exception $ fixe",
  accepted_grain_types: "Spécialisation historique",
  address: "Adresse",
  aspirator: "Aspirateur",
  ontario: "Ontario",
  aspirator_service_minutes: "Temps aspirateur (min)",
  axle_count: "Essieux",
  billing_approval_status: "Approbation facturation",
  billing_approved_at: "Approuvée le",
  billing_approved_by_email_snapshot: "Approuvée par (courriel)",
  billing_approved_by_user_id: "Approuvée par",
  has_historical_assignments: "Affectations historiques",
  avg_speed_kmh: "Vitesse",
  cabin_size: "Cabine",
  capacity_tons: "Capacité",
  cancelled_at: "Annulée le",
  client_code: "Code client",
  client_name: "Client",
  client_record: "Fiche client",
  comment: "Commentaire",
  compartment_count: "Nombre de cuves",
  compartment_id: "ID compartiment",
  compartment_capacity_tons: "Profil cuves",
  compartment_name: "Remorque",
  evening_radius_km: "Rayon Soir (km)",
  evening_is_active: "Actif Soir",
  unit_kind: "Genre",
  tractor_retired_on: "Camion retiré le",
  trailer_retired_on: "Remorque retirée le",
  compartments: "Compartiments",
  coop: "Facturer à",
  correspondence_id: "ID correspondance",
  correspondence_name: "Nom correspondance",
  correction_reason: "Motif de correction",
  created_order_ids: "N° commandes ajoutées",
  actual_loaded_quantity_tons: "Chargé réel (t)",
  execution_driver_updated: "chauffeur livreur mis à jour",
  execution_tonnages_recorded: "enregistré et marquée livrée",
  deleted_order_id: "N° commande supprimée",
  departure_address: "Adresse de départ",
  delivery_date: "Date livraison",
  delivery_fixed_minutes: "Temps fixe par livraison (min)",
  loading_fixed_minutes: "Temps fixe par chargement (min)",
  trip_fixed_minutes: "Temps fixe par trajet (min)",
  aspirator_rate_tons_per_hour: "Débit d'aspiration (t/h)",
  lunch_break_minutes: "Pause dîner (min)",
  driver_user_id: "Conducteur",
  driver_name: "Chauffeur",
  evening_driver_name: "Chauffeur soir",
  courriel: "Courriel",
  telephone: "Téléphone",
  indication: "Indication",
  employee_id: "ID employé",
  employee_name: "Nom employé",
  is_driver: "Chauffeur",
  product_id: "ID produit",
  article_number: "No Article",
  product_value: "Produit",
  density: "Densité",
  correspondence: "Correspondance",
  name: "Nom",
  dispatch_status: "Statut dispatch",
  end_time: "Fin",
  source_kind: "Source",
  source_label: "Origine",
  fuel_cost_per_km: "Coût carburant / km",
  fuel_cost_per_km_cad: "Coût carburant / km",
  grain_code: "Code produit",
  grain_type: "Produit",
  inter_delivery_buffer_min: "Buffer",
  truck_id: "Code camion",
  inspection_time_minutes: "Temps d'inspection (min)",
  is_meunerie: "Meunerie",
  is_coop: "Entreprise facturée",
  bill_to: "Facturer à",
  meunerie_loading_extra_minutes: "Surtemps meunerie (min)",
  loading_opening_time: "Heure ouverture chargement",
  loading_closing_time: "Heure fermeture chargement",
  is_active: "Actif",
  is_initial_preload_enabled: "Pool preload",
  loading_rate_tons_per_hour: "Débit de chargement (t/h)",
  loading_silo: "Silo",
  lock_reason: "Verrou",
  max_volume_m3: "Volume max",
  max_weight_tons: "Poids max",
  max_work_hours: "Heures max",
  preferred_grain_type: "Produit associé",
  order_date: "Date commande",
  order_id: "Commande",
  position: "Position",
  quantity_tons: "Quantité (t)",
  restrictions: "Restrictions",
  start_time: "Début journée conducteur",
  start_depot_id: "Dépôt de départ",
  end_depot_id: "Dépôt de fin",
  home_base_id: "Base",
  tags: "Tags",
  truck_name: "Nom",
  tractor_name: "Camion",
  truck_type: "Type de camion",
  unloading_rate_tons_per_hour: "Débit de déchargement (t/h)",
  waiting_cost_per_min: "Coût attente / min",
  waiting_cost_per_minute_cad: "Coût attente / min",
  work_order_number: "OT",
  shift: "Quart",
  evening_start_time: "Début Soir",
  evening_max_work_hours: "Heures max Soir",
  lunch_time: "Heure du dîner",
  evening_dispatch_start_time: "Départ du soir",
  evening_dispatch_max_work_hours: "Durée du soir",
};

const DATA_MANAGER_COMPACT_FIELD_LABELS = {
  delivery_date: "date livraison",
  end_time: "fin journée",
  loading_closing_time: "fermeture chargement",
  loading_opening_time: "ouverture chargement",
  order_date: "date commande",
  start_time: "début journée",
};

const DATA_MANAGER_SAFE_BOOLEAN_FIELDS = new Set([
  "aspirator",
  "has_historical_assignments",
  "is_active",
  "is_initial_preload_enabled",
  "is_meunerie",
  "is_coop",
  "is_preloaded_previous_day",
  "ontario",
]);

const DATA_MANAGER_SAFE_DATE_FIELDS = new Set([
  "delivery_date",
  "order_date",
]);

const DATA_MANAGER_SAFE_NUMBER_FIELDS = new Set([
  "aspirator_rate_tons_per_hour",
  "aspirator_service_minutes",
  "avg_speed_kmh",
  "axle_count",
  "capacity_tons",
  "compartment_count",
  "delivery_fixed_minutes",
  "density",
  "evening_max_work_hours",
  "evening_dispatch_max_work_hours",
  "fuel_cost_per_km",
  "fuel_cost_per_km_cad",
  "inspection_time_minutes",
  "inter_delivery_buffer_min",
  "loading_fixed_minutes",
  "loading_rate_tons_per_hour",
  "lunch_break_minutes",
  "max_volume_m3",
  "max_weight_tons",
  "max_work_hours",
  "meunerie_loading_extra_minutes",
  "position",
  "quantity_tons",
  "trip_fixed_minutes",
  "unloading_rate_tons_per_hour",
  "waiting_cost_per_min",
  "waiting_cost_per_minute_cad",
]);

const DATA_MANAGER_SAFE_TIME_FIELDS = new Set([
  "end_time",
  "evening_start_time",
  "lunch_time",
  "evening_dispatch_start_time",
  "loading_closing_time",
  "loading_opening_time",
  "start_time",
]);

function normalizeDataManagerFieldName(fieldName) {
  return typeof fieldName === "string" ? fieldName.trim().toLowerCase() : "";
}

function formatDataManagerSafeBoolean(value) {
  const normalizedValue = typeof value === "string" ? value.trim().toLowerCase() : value;
  if (
    normalizedValue === true
    || normalizedValue === 1
    || normalizedValue === "1"
    || normalizedValue === "true"
    || normalizedValue === "oui"
    || normalizedValue === "yes"
  ) {
    return "Oui";
  }
  if (
    normalizedValue === false
    || normalizedValue === 0
    || normalizedValue === "0"
    || normalizedValue === "false"
    || normalizedValue === "non"
    || normalizedValue === "no"
  ) {
    return "Non";
  }
  return value === null ? "—" : "";
}

function formatDataManagerSafeDate(value) {
  if (value === null) {
    return "—";
  }
  const normalizedValue = typeof value === "string" ? value.trim() : "";
  return /^\d{4}-\d{2}-\d{2}$/.test(normalizedValue) ? normalizedValue : "";
}

function formatDataManagerSafeNumber(value) {
  if (value === null) {
    return "—";
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? String(value).replace(".", ",") : "";
  }
  const normalizedValue = typeof value === "string" ? value.trim() : "";
  return /^-?\d+(?:[.,]\d+)?$/.test(normalizedValue)
    ? normalizedValue.replace(".", ",")
    : "";
}

function formatDataManagerSafeTime(value) {
  if (value === null) {
    return "—";
  }
  const normalizedValue = typeof value === "string" ? value.trim() : "";
  const match = normalizedValue.match(/^(\d{2}:\d{2})(?::(\d{2}))?$/);
  if (!match) {
    return "";
  }
  return match[2] && match[2] !== "00"
    ? `${match[1]}:${match[2]}`
    : match[1];
}

export function formatDataManagerAuditFieldLabel(fieldName, { compact = false, fallbackLabel = "" } = {}) {
  const normalizedFieldName = normalizeDataManagerFieldName(fieldName);
  if (compact && DATA_MANAGER_COMPACT_FIELD_LABELS[normalizedFieldName]) {
    return DATA_MANAGER_COMPACT_FIELD_LABELS[normalizedFieldName];
  }
  return DATA_MANAGER_HISTORY_FIELD_LABELS[normalizedFieldName]
    || (typeof fallbackLabel === "string" ? fallbackLabel.trim() : "")
    || normalizedFieldName.replace(/_/g, " ")
    || "Champ";
}

export function formatDataManagerAuditSafeFieldValue(fieldName, value) {
  const normalizedFieldName = normalizeDataManagerFieldName(fieldName);
  if (DATA_MANAGER_SAFE_BOOLEAN_FIELDS.has(normalizedFieldName)) {
    return formatDataManagerSafeBoolean(value);
  }
  if (DATA_MANAGER_SAFE_DATE_FIELDS.has(normalizedFieldName)) {
    return formatDataManagerSafeDate(value);
  }
  if (DATA_MANAGER_SAFE_NUMBER_FIELDS.has(normalizedFieldName)) {
    return formatDataManagerSafeNumber(value);
  }
  if (DATA_MANAGER_SAFE_TIME_FIELDS.has(normalizedFieldName)) {
    return formatDataManagerSafeTime(value);
  }
  return "";
}
